import React from "react";
import Divider from "@material-ui/core/Divider";
import { Link } from "react-router-dom";

export default function DoctorsList() {
  return (
    <>
      <h2 data-toggle="collapse" data-target="#nurse" className="navhead">
        Nurse
      </h2>
      <Divider />
      <div class="collapse indent" id="nurse">
        {/* Videos */}
        <Link className="video" to="/NurseVideo">
          <h3 data-toggle="collapse">Videos</h3>
        </Link>
        <Divider />
        {/* Patient MGMT */}
        <h3 data-toggle="collapse" data-target="#NursepatientMgmt">
          Patient Management
        </h3>
        <Divider />
        <ul id="NursepatientMgmt" class="collapse">
        <Link to="/MergePatient">
            <li>Merge Patient</li>
          </Link>
          <Link to="/CreateNewPatient">
            <li>Create New Patient</li>
          </Link>
          <Link to="/CreateAppointment">
            <li>Create Appointment</li>
          </Link>
          <Link to="/EditPatientInfo">
            <li>Edit Patient Info</li>
          </Link>
          <Link to="/AddReferraltoPatient">
            <li>Add Referral</li>
          </Link>
          <Link to="/AddPatientFiles">
            <li>Add Patient Files</li>
          </Link>
          <Link to="/AddGeneralNotes">
            <li>Add General Notes</li>
          </Link>
          <Link to="/ViewPatientForms">
            <li>View Patient Forms</li>
          </Link>
          <Link to="/ViewAddress">
            <li>View Address</li>
          </Link>
          <Link to="/ViewAddClinicNts">
            <li>Clinical Notes</li>
          </Link>
          <Link to="/CancelPatients">
            <li>Cancel Patients</li>
          </Link>
          <Link to="/ScanDocs">
            <li>Scan Documents</li>
          </Link>
          <Link to="/RequestXRay">
            <li>Request X-Ray</li>
          </Link>
          <Link to="/WaitingReview">
            <li>Waiting Review</li>
          </Link>
          <Link to="/AdmitPatient">
            <li>Admit Patient</li>
          </Link>
          <Link to="/Discharge">
            <li>Discharge</li>
          </Link>
        </ul>
        {/* Calendar */}
        <h3 data-toggle="collapse" data-target="#nurse1">
          Calendar
        </h3>
        <Divider />
        <ul id="nurse1" class="collapse">
          <Link to="/ViewAllAppointments">
            <li>View All Appointments</li>
          </Link>
          <Link to="/ViewDocAppointments">
            <li>View Other Doctor's Appointments</li>
          </Link>
          <Link to="/ViewDocCalendars">
            <li>View Doctor's Calendars</li>
          </Link>
        </ul>
        {/* Misc */}
        <h3 data-toggle="collapse" data-target="#nurse2">
          Misc
        </h3>
        <Divider />
        <ul id="nurse2" class="collapse">
          <Link to="/ViewReports">
            <li>View Reports</li>
          </Link>
          <Link to="/ViewDashboard">
            <li>View Dashboards</li>
          </Link>
          <Link to="/SearchPatients">
            <li>Search Patients</li>
          </Link>
          <Link to="/ViewPolicies">
            <li>View Policies and procedures</li>
          </Link>
        </ul>
      </div>
    </>
  );
}
